import { useEffect, useRef } from 'react'
import { changeUser, initialize } from '@braze/web-sdk'
import { getBrandConfig } from '@/config/config'
import { useOidc } from '@/features/oidc/oidc'

export const useBrazeInit = () => {
  const isBrazeInitialized = useRef(false)
  const isUserIdentified = useRef(false)
  const { isUserLoggedIn, decodedIdToken } = useOidc()
  const userId = decodedIdToken?.['pam-aid']

  const {
    braze: { apiKey, baseUrl },
  } = getBrandConfig()

  useEffect(() => {
    try {
      if (!isBrazeInitialized.current) {
        if (initialize(apiKey, { baseUrl })) {
          isBrazeInitialized.current = true
        }
      }

      if (
        !isUserIdentified.current &&
        isBrazeInitialized.current &&
        isUserLoggedIn &&
        userId
      ) {
        changeUser(userId)

        isUserIdentified.current = true
      }
    } catch (e) {
      console.error('Braze: Failed to initialize or identify user.', e)
    }
  }, [apiKey, baseUrl, isUserLoggedIn, userId])
}
